"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableColumnsDisplayGrid = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var react_1 = __importDefault(require("react"));
var Localize_1 = require("../../../gen-src/Localize");
var queries_1 = require("../../../gen-src/queries");
var NumberCellFormatter_1 = require("../datagrid/cellFormatters/NumberCellFormatter");
var QueryPreservingLinkCellFormatter_1 = require("../datagrid/cellFormatters/QueryPreservingLinkCellFormatter");
var RemoteTypeIcon_1 = require("../datagrid/cellFormatters/RemoteTypeIcon");
var TagCellFormatter_1 = require("../datagrid/cellFormatters/TagCellFormatter");
var ColumnInlineActionsMenu_1 = require("./ColumnInlineActionsMenu");
function columns(siteUrls, canUpdate) {
    var cols = [
        function () { return (0, data_catalog_shared_1.createSelectionColumn)(); },
        function () { return createLabelWarningColumnFormatter(siteUrls); },
        function () { return ({
            name: 'warning',
            dataKey: '',
            headerText: '',
            headerTooltip: Localize_1.Messages.DataQualityWarningTitle(),
            headerFormatter: data_catalog_shared_1.DataQualityIconHeaderFormatterFactory,
            cellFormatter: createColumnDataQualityCellFormatter({
                getWarningsFromRowData: function (r) { return r.__typename === 'Column' ? r.dataQualityWarnings : undefined; }
            }),
            sortable: false,
            resizable: false,
        }); },
        function (sortParams) { return ({
            name: 'type',
            dataKey: data_catalog_shared_1.UnsortableColumnKey,
            headerText: Localize_1.Messages.GridHeaderType(),
            headerFormatter: (0, data_catalog_shared_1.createSortableHeaderFormatter)(sortParams),
            cellFormatter: (0, data_catalog_shared_1.createIconCellFormatter)(function (_a) {
                var remoteType = _a.remoteType;
                return react_1.default.createElement(RemoteTypeIcon_1.RemoteTypeIcon, { remoteType: remoteType });
            }, function (_a) {
                var remoteType = _a.remoteType;
                return data_catalog_shared_1.RemoteTypeMappings[remoteType]();
            }),
            resizable: false,
            sortable: false,
        }); },
        function (sortParams) { return ({
            name: 'name',
            dataKey: queries_1.ColumnOrderField.NAME,
            headerText: Localize_1.Messages.GridHeaderName(),
            headerFormatter: (0, data_catalog_shared_1.createSortableHeaderFormatter)(sortParams),
            cellFormatter: (0, QueryPreservingLinkCellFormatter_1.createQueryPreservingReplacingLinkCellFormatter)(function (_a) {
                var name = _a.name;
                return name || '';
            }, function (urls, _a) {
                var id = _a.id, tableId = _a.tableId;
                return urls.catalogTableColumnPath(tableId, id);
            }),
            resizable: true,
            sortable: true,
        }); },
        function (sortParams) { return ({
            name: 'actionsmenu',
            dataKey: data_catalog_shared_1.UnsortableColumnKey,
            headerText: Localize_1.Messages.Actions(),
            headerFormatter: (0, data_catalog_shared_1.createSortableHeaderFormatter)(sortParams),
            cellFormatter: createColumnActionsCellFormatter({
                getColumnIdFromRowData: function (r) { return r.__typename === 'Column' ? r.id : ''; },
                getColumnLuidFromRowData: function (r) { return r.luid; },
                getColumnNameFromRowData: function (r) { var _a; return (_a = r.name) !== null && _a !== void 0 ? _a : ''; },
                getColumnRemoteTypeFromRowData: function (r) { return r.remoteType; },
                getTableVizportalId: function (r) { return r.vizportalId ? r.vizportalId : ''; },
                canUpdate: canUpdate,
            }),
            resizable: false,
            sortable: false,
        }); },
        function (sortParams) { return ({
            name: 'connectedSheets',
            dataKey: data_catalog_shared_1.UnsortableColumnKey,
            headerText: Localize_1.Messages.GridHeaderSheets(),
            headerFormatter: (0, data_catalog_shared_1.createSortableHeaderFormatter)(sortParams, 'right'),
            cellFormatter: (0, NumberCellFormatter_1.createNumberCellFormatter)(function (_a) {
                var sheetCount = _a.sheetCount;
                return sheetCount;
            }),
            sortable: false,
        }); },
        function (sortParams) { return ({
            name: 'connectedDatasources',
            dataKey: data_catalog_shared_1.UnsortableColumnKey,
            headerText: Localize_1.Messages.GridHeaderDatasources(),
            headerFormatter: (0, data_catalog_shared_1.createSortableHeaderFormatter)(sortParams, 'right'),
            cellFormatter: (0, NumberCellFormatter_1.createNumberCellFormatter)(function (_a) {
                var datasourceCount = _a.datasourceCount;
                return datasourceCount;
            }),
            sortable: false,
        }); },
        function (sortParams) { return ({
            name: 'description',
            dataKey: data_catalog_shared_1.UnsortableColumnKey,
            headerText: Localize_1.Messages.GridHeaderDescription(),
            headerFormatter: (0, data_catalog_shared_1.createSortableHeaderFormatter)(sortParams),
            cellFormatter: (0, data_catalog_shared_1.createTextCellFormatter)(function (_a) {
                var description = _a.description;
                return description;
            }, Localize_1.Messages.NoDescriptionGridPlaceholder()),
            sortable: false,
            growToFit: true,
        }); },
        function (sortParams) { return ({
            name: 'tags',
            dataKey: data_catalog_shared_1.UnsortableColumnKey,
            headerText: Localize_1.Messages.GridHeaderTags(),
            headerFormatter: (0, data_catalog_shared_1.createSortableHeaderFormatter)(sortParams),
            cellFormatter: (0, TagCellFormatter_1.createTagCellFormatter)(function (_a) {
                var tags = _a.tags;
                return tags !== null && tags !== void 0 ? tags : [];
            }),
            sortable: false,
            growToFit: true
        }); },
    ];
    return cols.filter(Boolean);
}
function TableColumnsDisplayGrid(props) {
    var labelsInMorePlacesEnabled = react_1.default.useContext(data_catalog_shared_1.FeatureFlagsContext).labelsInMorePlacesEnabled;
    var canUpdate = useCanUserSetColumnDescription(props.tableVizportalId);
    var siteUrls = react_1.default.useContext(data_catalog_shared_1.SiteUrlsContext);
    var cols = columns(siteUrls, canUpdate)
        .map(function (columnFactory) { return columnFactory(props); })
        .filter(function (column) {
        if (column.name === 'label-warning' && !labelsInMorePlacesEnabled) {
            return false;
        }
        if (column.name === 'warning' && labelsInMorePlacesEnabled) {
            return false;
        }
        return true;
    });
    return (react_1.default.createElement(data_catalog_shared_1.ExplorerStyledDisplayGrid, { columns: cols, rowStore: props.rowStore, selectedKeys: props.selectedKeys, updateSelectionForKey: props.updateSelectionForKey, rowCount: props.rowCount, renderErrors: data_catalog_shared_1.reportGraphQLErrors, orderBy: props.orderBy, updateSortOrder: props.updateSortOrder }));
}
exports.TableColumnsDisplayGrid = TableColumnsDisplayGrid;
var IconStyle = {
    position: 'relative',
    left: '13.4px',
    top: '2px'
};
function createColumnDataQualityCellFormatter(opts) {
    var getWarningsFromRowData = opts.getWarningsFromRowData, linksDisabled = opts.linksDisabled;
    return function (props) {
        var anchoredWarnings = getWarningsFromRowData(props.row.data);
        var warning = anchoredWarnings && anchoredWarnings[0] ? anchoredWarnings[0] : undefined;
        if (!warning) {
            return (react_1.default.createElement(react_1.default.Fragment, null));
        }
        return react_1.default.createElement(data_catalog_shared_1.SiteUrlsContext.Consumer, null, function (urls) { return (react_1.default.createElement("div", { style: IconStyle },
            react_1.default.createElement(data_catalog_shared_1.WarningStatusIcon, { iconOnly: true, kind: 'graph', upstreamWarnings: [], subjectArea: 'Column', anchoredAsset: warning, anchoredWarnings: anchoredWarnings !== null && anchoredWarnings !== void 0 ? anchoredWarnings : [], urls: linksDisabled ? undefined : urls, linksDisabled: linksDisabled }))); });
    };
}
var ActionsCellStyle = {
    display: 'flex',
    flexGrow: 1,
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'center',
};
function useCanUserSetColumnDescription(tableVizportalId) {
    var _this = this;
    var canUserSetColumnDescription = react_1.default.useContext(data_catalog_shared_1.ApiRequestsContext).canUserSetColumnDescription;
    var _a = react_1.default.useState(false), canUpdate = _a[0], setCanUpdate = _a[1];
    react_1.default.useEffect(function () {
        var subscribed = true;
        var fetchData = function () { return __awaiter(_this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, canUserSetColumnDescription({ tableVizportalId: tableVizportalId })];
                    case 1:
                        data = _a.sent();
                        if (subscribed) {
                            setCanUpdate(data);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        void fetchData().catch();
        return function () { subscribed = false; };
    }, [canUserSetColumnDescription, tableVizportalId]);
    return (canUpdate);
}
function createColumnActionsCellFormatter(opts) {
    var getColumnIdFromRowData = opts.getColumnIdFromRowData, getColumnLuidFromRowData = opts.getColumnLuidFromRowData, getColumnNameFromRowData = opts.getColumnNameFromRowData, getColumnRemoteTypeFromRowData = opts.getColumnRemoteTypeFromRowData, getTableVizportalId = opts.getTableVizportalId, canUpdate = opts.canUpdate;
    return function (props) {
        var columnId = getColumnIdFromRowData(props.row.data);
        var tableVizportalId = getTableVizportalId(props.row.data);
        var luid = getColumnLuidFromRowData(props.row.data);
        var name = getColumnNameFromRowData(props.row.data);
        var remoteType = getColumnRemoteTypeFromRowData(props.row.data);
        return (react_1.default.createElement("div", { style: ActionsCellStyle },
            react_1.default.createElement("div", null,
                react_1.default.createElement(ColumnInlineActionsMenu_1.ColumnInlineActionsMenu, { columnId: columnId, columnLuid: luid, columnName: name, columnRemoteType: remoteType, tableVizportalId: tableVizportalId, canUpdate: canUpdate }))));
    };
}
function createLabelWarningColumnFormatter(urls) {
    function getWarningPropsFromRowData(rowData) {
        var _a;
        var dataQualityWarnings = rowData.dataQualityWarnings ? rowData.dataQualityWarnings : [];
        var isActive = dataQualityWarnings.some(function (warning) { return warning.isActive; });
        var severity = dataQualityWarnings.some(function (warning) { return warning.isActive && warning.isSevere; });
        return {
            catalogEnabled: true,
            content: {
                contentId: rowData.id,
                contentLuid: rowData.luid,
                contentType: 'column',
                contentName: (_a = rowData.name) !== null && _a !== void 0 ? _a : undefined,
                contentUrl: urls.catalogTableColumnUrl(rowData.tableId, rowData.id),
                subjectArea: 'Column',
                remoteType: rowData.remoteType
            },
            probablyOrEager: isActive ? {
                warning: {
                    kind: 'warning',
                    severe: severity
                }
            } : undefined,
            testId: 'table-columns-warning-column',
            controls: {
                kind: 'icon',
                siteUrls: urls,
            }
        };
    }
    return (0, data_catalog_shared_1.createLabelColumnFormatter)('warning', { overrides: {}, getPropsFromRowData: getWarningPropsFromRowData });
}
//# sourceMappingURL=TableColumnsDisplayGrid.js.map